import * as yup from 'yup';

let createTicketValidationForm = yup.object().shape({
    queue: yup.string().required("Subject is required"),
    priority: yup.string().required("Priority is required"),
    description: yup.string().required("Description is required")
})
let paymentValidationForm = yup.object().shape({
    payment_method: yup.string().required("Payment method is required"),
  });
  

export {
    createTicketValidationForm,
    paymentValidationForm
}